import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import { Routings } from './Config'
import Loading from './Component/Loading'
import ProtectedRoute from './Component/ProtectedRoute'
import NotFoundPage from './Pages/NotFoundPage'
import PublicLayout from './Component/PublicLayout'
import UserLayout from './Component/UserLayout'
import AdminLayout from './Component/AdminLayout'
import DynamicLayout from './Component/DynamicLayout'

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        {/* Public Layout Routes */}
        <Route element={<PublicLayout />}>
          {Routings.filter((r) => r.layout === 'public').map((route) => {
            const DynamicComponent = route.importFrom
            return (
              <Route
                key={route.id}
                path={route.path}
                element={<DynamicComponent />}
              />
            )
          })}
        </Route>

        {/* User Layout Routes */}
        <Route element={<UserLayout />}>
          {Routings.filter((r) => r.layout === 'user').map((route) => {
            const DynamicComponent = route.importFrom
            return (
              <Route
                key={route.id}
                path={route.path}
                element={
                  route.isProtected ? (
                    <ProtectedRoute role={route.userType}>
                      <DynamicComponent />
                    </ProtectedRoute>
                  ) : (
                    <DynamicComponent />
                  )
                }
              />
            )
          })}
        </Route>

        {/* Admin Layout Routes */}
        <Route element={<AdminLayout />}>
          {Routings.filter((r) => r.layout === 'admin').map((route) => {
            const DynamicComponent = route.importFrom
            return (
              <Route
                key={route.id}
                path={route.path}
                element={
                  route.isProtected ? (
                    <ProtectedRoute role={route.userType}>
                      <DynamicComponent />
                    </ProtectedRoute>
                  ) : (
                    <DynamicComponent />
                  )
                }
              />
            )
          })}
        </Route>

        {/* Dynamic Layout Routes (Shared) */}
        <Route element={<DynamicLayout />}>
          {Routings.filter((r) => r.layout === 'dynamic').map((route) => {
            const DynamicComponent = route.importFrom
            return (
              <Route
                key={route.id}
                path={route.path}
                element={
                  route.isProtected ? (
                    <ProtectedRoute role={route.userType}>
                      <DynamicComponent />
                    </ProtectedRoute>
                  ) : (
                    <DynamicComponent />
                  )
                }
              />
            )
          })}
        </Route>

        <Route path='/*' element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
